import type { AxiosRequestConfig } from 'axios'
import { apiClient } from './service'

export async function customInstance<T>(
  config: AxiosRequestConfig,
  options?: AxiosRequestConfig,
): Promise<T> {
  const response = await apiClient({
    ...config,
    ...options,
    signal: options?.signal ?? config.signal,
  })

  return response.data
}
